import type { GridElement } from '@omnia/ui/src/lib'
import { type FC, memo } from 'react'
import { urlFriendly } from '@/common/utils/urls/urlFriendly'

export const Headline: FC<GridElement<string>> = memo(
    props => {
        const idValue = urlFriendly(props.value).toLowerCase()

        return (
            <div className="component-title-container" id={idValue}>
                <h2 className="component-title-container__content">{props.value}</h2>
            </div>
        )
    },
    (p, n) => p.value === n.value
)
